<crown-x-overlay></crown-x-overlay>
<crown-x-dialog #UserSessionTimeoutDialog class="user-session-dialog" DialogTitle="User Session Timeout" (OkButtonClick)="OnTimeoutDialogOkayClick()">
	Your session has timed out. You will need to log back in.
</crown-x-dialog>
<crown-x-dialog #UserLoggedInElsewhereDialog class="user-session-dialog" DialogTitle="User Session Elsewhere" (OkButtonClick)="OnLoggedInElsewhereDialogOkayClick()">
	You are logged in elsewhere.
</crown-x-dialog>
<crownx-version-upgrade></crownx-version-upgrade>
<crown-x-toast-list></crown-x-toast-list>
<router-outlet></router-outlet>